module.exports = __webpack_public_path__ + "img/home_todo_item3.9b46b1fc.png";